import React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../css/Form.css";
import Utils from "../../../../helper/Utils";

const FamilyDetails = (props) => {
  const {
    onChangeHandler,
    SelectedFormState,
    MaritalOptions,
    selectHandler,
    AddMoreHandler,
    RemoveHandler,
    interviewDetails,
    DateChangeHandler,
    familyDependentChangeHandler,selectedRoundData,dependentDetailsHandler
  } = props;

    return (
    <div>
      <div className="appDivider" />
      <h5 className="">Family/Dependent Details</h5>
      <div className="appDivider" />
      {interviewDetails.editable ? (
        <div className="formWrapper">
          <div className="row">
            <div className="col-md-3 col-xs-12">
              <label className="appFormLabel">Marital status</label>
            </div>
            <div className="col-md-3 col-xs-12">
              <Select
                className="z-depth-3"
                value={SelectedFormState.MaritalStatus ||""}
                onChange={(selected) => selectHandler(selected, "MaritalStatus")}
                options={MaritalOptions}
                isDisabled={interviewDetails.editable === false ? true : false}
              />
            </div>
          </div>
        </div>
      ) : null}
      <div className="table table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{}</th>
              <th>
                <label>Name</label>
              </th>
              <th>
                <label>Date of birth</label>
              </th>
              <th>
                <label>Qualification</label>
              </th>
              <th>
                <label>Profession</label>
              </th>
            </tr>
          </thead>
          <tbody>
         {SelectedFormState.familyDetailsAddtnlList.sort((x,y)=>x?.relationship.localeCompare( y?.relationship)).map((item, index)=>{    
              return(
            <tr key={index}>
              <td>
                <label>{item.relationship}</label>
              </td>
              <td>
                <input
                  className="form-control z-depth-3"
                  onChange={(e)=>familyDependentChangeHandler(e,"dependentName",index)}
                  value={item.dependentName || ""}
                  name="dependentName"
                  type="text"
                  maxLength="100"
                  disabled={interviewDetails.editable === false ? true : false}
                />
              </td>
              <td>
                <DatePicker
                  selected={Utils.convertLocalDateToDateObj(item.dependDOB)}
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd-MMM-yyyy"
                  className="form-control z-depth-3"
                  dropdownMode="select"
                  autoComplete="off"
                  placeholderText="DD-MMM-YYYY"
                  maxDate={new Date()}
                  disabled={interviewDetails.editable === false ? true : false}
                  onChange={(date) => DateChangeHandler(date, "dependDOB", index, "familyDetailsAddtnlList")}
                />
              </td>
              <td>
                <input
                  className="form-control z-depth-3"
                  onChange={(e)=>familyDependentChangeHandler(e,"dependentQualification",index)}
                  value={item.dependentQualification||""}
                  name="dependentQualification"
                  type="text"
                  maxLength="100"
                  disabled={interviewDetails.editable === false ? true : false}
                />
              </td>
              <td>
                <input
                  className="form-control z-depth-3"
                  onChange={(e)=>familyDependentChangeHandler(e,"dependentProfession",index)}
                  value={item.dependentProfession ||""}
                  name="dependentProfession"
                  type="text"
                  maxLength="100"
                  disabled={interviewDetails.editable === false ? true : false}
                />
              </td>
           </tr>
            )
})}
          </tbody>
        </table>
      </div>
    <div className="appDivider" />
      {/* <h5 className="">Dependents Details (If any)</h5> */}
      {/* <div className="appDivider" /> */}
      <div>
        <div className="">
          <div className="table table-responsive" style={{ overflow: "hidden" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  {/* <th>{}</th> */}
                  <th style={{ width: "30%" }}>
                    <label>Name</label>
                  </th>
                  <th style={{ width: "15s%" }}>
                    <label>Date of birth</label>
                  </th>
                  <th  style={{ width: "30%" }}>
                    <label>Relationship</label>
                  </th>
				  <th>{}</th>
                </tr>
              </thead>
              <tbody>
                {SelectedFormState.dependentDetailsAddtnlList.map((el, index) => (
                  <tr key={index}>
                    {/* <td>Dependent {index + 1}</td> */}
                    <td>
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => dependentDetailsHandler(event, "dependentName", index)}
                        value={el.dependentName||""}
                        id={index + "dependentName"}
                        name="dependentName"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails.editable === false ? true : false}
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={Utils.convertLocalDateToDateObj(el.dependDOB)}
                        showMonthDropdown
                        showYearDropdown
                        dateFormat="dd-MMM-yyyy"
                        className="form-control z-depth-3"
                        dropdownMode="select"
                        autoComplete="off"
                        placeholderText="DD-MMM-YYYY"
                        maxDate={new Date()}
                        disabled={interviewDetails.editable === false ? true : false}
                        onChange={(date) => DateChangeHandler(date, "dependDOB", index, "dependentDetailsAddtnlList")}
                      />
                    </td>
                    <td>
                      {" "}
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => dependentDetailsHandler(event, "relationship", index)}
                        value={el.relationship||""}
                        id={index + "relationship"}
                        name="relationship"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails.editable === false ? true : false}
                      />
                    </td>
                    <td>
                      {interviewDetails.editable ? (
                        <div className="row">
                          <div className="col-md-12">
                            <button
                              type="button"
                              style={{ margin: 0 }}
                              className="RemoveLinkButton pull-right z-depthButton"
                              onClick={RemoveHandler}
                              id={index}
                              name="RemoveDependent"
                            >
                              <i className="fa fa-trash RemoveIcon" />
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
              {interviewDetails.editable ? (
                <div className="row">
                  <div className="col-md-12">
                    <button type="button" className="formLinkButton pull-right z-depthButton" onClick={AddMoreHandler} name="AddmoreDependents">
                      <span className="fa fa-plus formAddIcon" /> Add more
                    </button>
                  </div>
                </div>
              ) : null}
          </div>
        </div>
        </div>
        
      <div className="formWrapper">
        <div className="row">
          <div className="col-md-2 col-xs-12">
            <label className="appFormLabel text">Family Background in brief</label>
          </div>
          <div className="col-md-5 col-xs-12 text-right">
            <textarea
              className="form-control z-depth-3"
              rows="5"
              name="familyBackgrounnd"
              maxLength={1000}
              onChange={onChangeHandler}
              value={SelectedFormState.familyBackgrounnd || ""}
              disabled={interviewDetails.editable === false ? true : false}
            />
            {SelectedFormState.familyBackgrounnd.length} / 1000
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDetails;
